const r = {
  Email: "EMAIL",
  Phone: "PHONE"
};
function o(n) {
  return e(n);
}
function e(n, t) {
  return n;
}
function a(n) {
  return n;
}
export {
  r as UsernameContactType,
  o as UsernameContactTypeFromJSON,
  e as UsernameContactTypeFromJSONTyped,
  a as UsernameContactTypeToJSON
};
//# sourceMappingURL=UsernameContactType.js.map
